import { apiClient } from '../../../../api/axios';
import type { ApiResponse } from '../common/types';
import type {
    DashboardStats,
    SubmissionChartData,
    ReviewerDashboardStats,
    DeskDashboardStats,
    ReviewerManagementStats,
} from './types';

export const dashboardService = {
    getAdminDashboardStatistics: async (): Promise<ApiResponse<DashboardStats>> => {
        const response = await apiClient.get('/Statistics/GetAdminDashboardStatistics');
        return response.data;
    },

    getSubmissionCharts: async (): Promise<ApiResponse<SubmissionChartData>> => {
        const response = await apiClient.get('/Statistics/GetSubmissionCharts');
        return response.data;
    },

    getReviewerDashboardStatistics: async (): Promise<ApiResponse<ReviewerDashboardStats>> => {
        const response = await apiClient.get('/Statistics/GetReviewerDashboardStatistics');
        return response.data;
    },

    getDeskDashboardStatistics: async (): Promise<ApiResponse<DeskDashboardStats>> => {
        const response = await apiClient.get('/Statistics/GetDeskDashboardStatistics');
        return response.data;
    },
};

export const reviewerManagementStatsService = {
    getReviewerManagementDashboardStatistics: async (): Promise<ApiResponse<ReviewerManagementStats>> => {
        const response = await apiClient.get('/Statistics/GetReviewerManagementDashboardStatistics');
        return response.data;
    },
};
